const features = [
  {
    icon: 'ri-shield-check-line',
    title: '高清无广告',
    desc: '所有漫画高清画质呈现，纯净阅读无广告干扰，沉浸式体验每一页漫画细节。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '热门漫画每日同步更新，完结经典定期上架，追更永不等候，精彩从不间断。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端适配',
    desc: '电脑、平板、手机完美适配，随时随地打开即读，移动阅读流畅不卡顿。',
  },
  {
    icon: 'ri-global-line',
    title: '海量资源',
    desc: '汇聚20000+部漫画，涵盖韩漫、日漫、国漫全品类，漫画大全一站尽览。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100 scroll-mt-header">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">平台特色</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">为什么选择漫蛙漫画网？四大优势给你答案</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}